export type FlowMenuPinScope = "global" | "project"

export const FLOW_MENU_GLOBAL_PINS_KEY = "flow-menu-pins"

export function flowMenuProjectPinsKey(projectId: number): string {
  return `flow-menu-pins:project:${projectId}`
}

/** Тип ноды закрепляется для всех проектов; герой, локация, реквизит, шот и цепочка есть только в своём проекте. */
export function flowMenuPinScope(key: string): FlowMenuPinScope {
  return key.startsWith("kind:") ? "global" : "project"
}

export function flowMenuPinStorageKey(key: string, projectId: number): string {
  return flowMenuPinScope(key) === "global" ? FLOW_MENU_GLOBAL_PINS_KEY : flowMenuProjectPinsKey(projectId)
}

export function toggleFlowMenuPin(pins: readonly string[], key: string): string[] {
  return pins.includes(key) ? pins.filter((item) => item !== key) : [...pins, key]
}

export function parseFlowMenuPins(raw: string | null): string[] {
  if (!raw) return []
  try {
    const value: unknown = JSON.parse(raw)
    if (!Array.isArray(value)) return []
    return [...new Set(value.filter((item): item is string => typeof item === "string"))]
  } catch {
    return []
  }
}
